/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Actionrunningheading2Inputs */

const en_actionrunningheading2 = /** @type {(inputs: Actionrunningheading2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Running action`)
};

const de_actionrunningheading2 = /** @type {(inputs: Actionrunningheading2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laufende Aktion`)
};

/**
* | output |
* | --- |
* | "Running action" |
*
* @param {Actionrunningheading2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const actionrunningheading2 = /** @type {((inputs?: Actionrunningheading2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actionrunningheading2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_actionrunningheading2(inputs)
	return de_actionrunningheading2(inputs)
});
export { actionrunningheading2 as "actionRunningHeading" }